import React, {useEffect, useState} from "react";
import style from "../../../../assets/scss/common/modal/addConsultationModal.module.scss";
import CloseBtn from "../../../../assets/images/modal/close_btn.svg";
import {useModal} from "../../../../hooks/hooks";
import {ConsultationApplyDTO, ConsultationItem, ConsultationReservation} from "../../../../types/consultation";
import {ReservationTitle} from "./ReservationTitle";
import {ReservationProfileInfo} from "./ReservationProfileInfo";
import {ReservationDateInput} from "./ReservationDateInput";
import {ReservationInquiry} from "./ReservationInquiry";
import {useConsultationReservationValidator} from "../../hooks/useConsultationReservationValidator";
import {useConsultationGetter} from "../../../sub/consultation/hooks/useConsultationGetter";
import {useModalScrollLock} from "./hooks/useModalScrollLock";
import {useTranslation} from "react-i18next";

interface AddChildModalProps {
  isOpen: boolean;
  onRefresh: (_: void) => void
  selectedConsultation: ConsultationItem | null;
  onClose: () => void;
}

const AddConsultationModal: React.FC<AddChildModalProps> = (
    { isOpen, onClose, selectedConsultation, onRefresh }
) => {
    const { t } = useTranslation("consultant");
    useModalScrollLock(isOpen); // 모달 밖 스크롤 제한

  const { openConfirmModal, openAlertModal } = useModal();
  const [selectedDate, setSelectedDate] = useState(t('detail.modal.defaultDayMonth'));
  const [selectedTime, setSelectedTime] = useState("");
  const [reservationIdx, setReservationIdx] = useState(0);
  const [childName, setChildName] = useState("");
  const [testInfo, setTestInfo] = useState("");
  const [inquiry, setInquiry] = useState("");
  const [availableTimes, setAvailableTimes] = useState<ConsultationReservation[]>([]); // 잔여석 데이터

  const {applyCounseling} = useConsultationGetter();

  const {isInquiryValidate, validate, setInquiryValidate} = useConsultationReservationValidator(
      {desiredTime: selectedTime, desiredDate:selectedDate, inquiry:inquiry}
  )

  useEffect(() => {
    setSelectedDate(t('detail.modal.defaultDayMonth'))
    setSelectedTime("")
    setReservationIdx(0)
    setChildName("")
    setTestInfo("0")
    setInquiry("")
    setAvailableTimes([])
      // eslint-disable-next-line
  }, [isOpen]);

  useEffect(() => {
    if (selectedConsultation) {
      const { userName, testRound, unitVoucherType } = selectedConsultation;

      if (userName && testRound && unitVoucherType) {
        setChildName(userName);
        setTestInfo(`${unitVoucherType} ${testRound}회차`)
      }
    }
  }, [selectedConsultation]);


  if (!isOpen) {
    return null;
  }

  const handleReservationConsultation = () =>{
    const validator = validate();
    if (!validator) return alert('상담 예약 작성폼을 다시 확인해주세요.');
    if (selectedConsultation === null) return;

    openConfirmModal(
        {
          title: t('modal.apply.title'),
          desc: `${t('modal.apply.desc1')}\n${t('modal.apply.desc2')}`,
        },
        () => {
          const body:ConsultationApplyDTO = {
            userProfileIdx: selectedConsultation.profileIdx,
            counselingReservationIdx: reservationIdx,
            contentExecutedInfoIdx: selectedConsultation.contentExecutedInfoIdx,
            preQuestioning:inquiry
          }
          applyCounseling(body).then(() =>{
            openAlertModal({
              title: t('modal.apply.title'),
              desc: t('modal.apply.complete'),
                callback: () =>{
                    onClose();
                    onRefresh();
                }
            })
          })
              .catch((error) => {
                openConfirmModal(
                    {
                      title: t('modal.apply.title'),
                      desc: `${t('modal.empty.desc1')}\n${t('modal.empty.desc2')}`,
                    },
                    () => {
                      window.open(`/purchase-counselor`, "_blank", "noopener,noreferrer");
                    }
                );
              })
        }
    );
  }

  return (
      <div className={style.addChildModalOverlay}>
        <div className={style.addChildInfoModal}>
          <div className={style.closeBtnContainer}>
            <img
                src={CloseBtn}
                alt="closeBtn"
                className={style.closeBtn}
                onClick={() => {
                  openConfirmModal(
                      {
                        title: t('modal.apply.title'),
                        desc: `${t('modal.apply.desc3')}\n${t('modal.apply.desc4')}\n${t('modal.apply.desc5')}`,
                      },
                      () => {
                        onClose();
                        setAvailableTimes([])
                        setSelectedDate(t('detail.modal.defaultDayMonth'));
                        setSelectedTime("");
                      }
                  );
                }}
            />
          </div>
          <div className={style.innerModalContainer}>
            <ReservationTitle subText={t('modal.apply.desc2')} />
            <ReservationProfileInfo childName={childName} testInfo={testInfo} />
            <ReservationDateInput
                selectedDate={selectedDate} setSelectedDate={setSelectedDate}
                selectedTime={selectedTime} setSelectedTime={setSelectedTime}
                availableTimes={availableTimes} setAvailableTimes={setAvailableTimes}
                setReservationIdx={setReservationIdx}
            />
            <ReservationInquiry inquiry={inquiry} setInquiry={setInquiry}
                                isInquiryValidate={isInquiryValidate} setIsInquiryValidate={setInquiryValidate}/>
            <button
                className={style.submitBtn}
                onClick={handleReservationConsultation}
                // disabled={!isFormValid()}
            >
                {t('btn.modal.apply')}
            </button>
          </div>
        </div>
      </div>
  );
};

export default AddConsultationModal;
